import { Redirect } from 'react-router-dom';

export default function View() {
  const pname = window.location.pathname;
  if (!pname.startsWith('/view//nld-realignment/')) {
    return (
      <>
        <br /> <br />
        <center>
          <h2 style={{ color: 'red' }}>
            Unable to redirect to BucketView: invalid path.
          </h2>
        </center>
      </>
    );
  }
  const key = pname.replace('/view//nld-realignment/', '');
  return <Redirect to={`/fileview?key=${encodeURIComponent(key)}`} />;
}
